



















































































































































































import { Component, Vue, Watch } from "@/shared/vuepack";
import {
  EmployeeNavItem,
  HsabAccountNametag,
  HsabExpenseEvidenceShoeboxModalSource,
  HsabExpenseFormMode,
  HsabExpenseFormType,
  HsabSsoDestination,
  ManagedExpenseFilterType
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import { hsabAccountIcon, hsaPlanTypeIcon } from "@/shared/awesomeIconMapper";
import HsaSubMenu from "@/employee/components/navBar/HsaSubMenu.vue";
import { useUserStore } from "@/shared/store/user";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useNavigationStore } from "@/shared/store/navigation";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabExpenseEditModal
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useThemeStore } from "@/shared/store/theme";
import { isMobileApp } from "@/shared/mobileHelper";
import { getNotionalAccountDisplay } from "@/employee/Utilities/HsabAccountUtility";
import { useFdicStore } from "@/shared/store/fdic";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";
import HsabExpenseEvidenceShoeboxModal
  from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoeboxModal.vue";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import LoginPromptOrchestrator from "@/employee/components/navBar/LoginPromptOrchestrator.vue";
import HsabExpenseDetailsModal
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";

@Component({
  computed: {
    ManagedExpenseFilterType () {
      return ManagedExpenseFilterType;
    }
  },
  components: {
    HsabExpenseDetailsModal,
    HsabExpenseEvidenceShoeboxModal,
    HsabExpenseEditModal,
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage,
    HsaSubMenu,
    LoginPromptOrchestrator,
  }
})
export default class AdvancedNav extends Vue {
  userStore = useUserStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  custodianSettingsStore = useCustodianSettingsStore();
  navigationStore = useNavigationStore();
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  hsabAccountsStore = useHsabAccountsStore();
  managedExpenseStore = useManagedExpenseStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  themeStore = useThemeStore();
  fdicStore = useFdicStore();
  shoeboxStore = useHsabExpenseEvidenceShoeboxStore();
  partnerPortalStore = usePartnerPortalStore();
  afterRoutedHook: any;
  RouteNames = RouteNames;
  hsaContainerIsVisible = false;
  navItemActive = EmployeeNavItem.None;
  HsabExpenseFormType = HsabExpenseFormType;

  @Watch("hsabAccountsStore.accountsFetchState")
  updateVisibleContainer () {
    if (this.hsabAccountsStore.hsaAccounts.length > 0 && this.hsabAccountsStore.notionalAccounts.length < 1) {
      this.hsaContainerIsVisible = true;
    }
  }

  @Watch("$route", {deep: true})
  watchRoute (newRoute, oldRoute) {
    this.handleInsideCollapse(newRoute);
    this.navItemActive = this.$router.currentRoute.meta.nav_item
      ? this.$router.currentRoute.meta.nav_item
      : EmployeeNavItem.None;
  }

  get settingsLinkActive () {
    return this.navItemActive === EmployeeNavItem.Settings;
  }

  get messageCenterLinkActive () {
    return this.navItemActive === EmployeeNavItem.Settings;
  }

  get resourcesLinkActive () {
    return this.navItemActive === EmployeeNavItem.Resources;
  }

  get expenseManagementLinkActive () {
    return this.navItemActive === EmployeeNavItem.ExpenseManagement;
  }

  get summaryLinkActive () {
    return this.navItemActive === EmployeeNavItem.Summary;
  }

  handleInsideCollapse (newRoute) {
    const insideCollapse = this.routesInsideHsaCollapse.some(x => x === newRoute.name);
    if (insideCollapse) {
      this.hsaContainerIsVisible = true;
    }
  }

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  mounted () {
    this.updateVisibleContainer();
    this.handleInsideCollapse(this.$route);
  }
  get routesInsideHsaCollapse () {
    const results = [
      RouteNames.Home,
      RouteNames.CashBalance,
      RouteNames.InvestmentAccountInfo,
      RouteNames.EligibleExpenses,
      RouteNames.HealthcareExpenses,
      RouteNames.Contribution,
      RouteNames.ContributionPlanner
    ];

    return results;
  }

  get showInHouseCreateExpenseButton () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasActiveAccount;
  }

  get showUploadShoeboxButton () {
    return this.featureFlagStore.flags.bend24844UploadShoeboxReceipts && !this.hsabAccountsStore.isNotionalOnly &&
      this.partnerPortalStore.hasActiveAccount;
  }

  onOpenShoeboxModalClicked () {
    this.shoeboxStore.openShoeboxModal(HsabExpenseEvidenceShoeboxModalSource.advancedNav);
  }

  get showShoeboxModal (): boolean {
    return this.shoeboxStore.isModalOpen &&
        this.shoeboxStore.modalOpenedBy === HsabExpenseEvidenceShoeboxModalSource.advancedNav;
  }

  get expenseFormType (): HsabExpenseFormType {
    return HsabExpenseFormType.AdvNav;
  }

  get isEverythingLoaded () {
    return this.custodianSettingsStore.isLoaded && this.featureFlagStore.featureFlagsAvailable;
  }

  get showExpenseManagementLink (): boolean {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get showAccountsSummaryLink (): boolean {
    const flagOff = !this.featureFlagStore.flags.bend25644EnableSummaryDashboard;
    return flagOff
        && (
            this.hasActiveAccount && this.hsabAccountsStore.userHasAnyNotionalAccounts
            || this.hsabAccountsStore.allHsabAccounts.length === 0 // New account creation (IOE users)
        );
  }

  get showSummaryLink (): boolean {
    const flagOn = this.featureFlagStore.flags.bend25644EnableSummaryDashboard;
    return flagOn
        && (
            this.hasActiveAccount
            || this.hsabAccountsStore.allHsabAccounts.length === 0 // New account creation (IOE users)
        );
  }

  get userHasHsaAccount (): boolean {
    return this.hsabAccountsStore.hsaAccounts && this.hsabAccountsStore.hsaAccounts.length > 0;
  }

  get showClosedAccountsLink (): boolean {
    return !this.hsabAccountsStore.userHasAnyActiveAccount
        && this.userHasInactiveAccounts;
  }

  get userHasInactiveAccounts (): boolean {
    return this.hsabAccountsStore.userHasAnyInactiveAccount;
  }

  get showExpensesLink (): boolean {
    const { HealthcareExpenses } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[HealthcareExpenses]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get hsabDeepLinkHome () {
    return HsabSsoDestination.Home;
  }

  get hsabDeepLinkPayment () {
    return HsabSsoDestination.DistributeFund;
  }

  get hsabDeepLinkMessageCenter () {
    return HsabSsoDestination.MessageCenter;
  }

  get hsabDeepLinkFileClaim () {
    return HsabSsoDestination.FileClaim;
  }

  get showProductScannerLink () {
    if (!isMobileApp()) {
      return false;
    }

    const { ProductScanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ProductScanner]) {
      return false;
    }

    if (this.bankAccountStore.isBankAccountClosed) {
      return false;
    }

    return true;
  }

  get showResourcesLink (): boolean {
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    return true;
  }

  get showSettingsLink (): boolean {
    const { Settings } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Settings]) {
      return false;
    }

    return true;
  }

  get showNotionalAccountsLinks () {
    return (this.notionalNavItems && this.notionalNavItems.length > 0) || this.userHasInactiveAccounts;
  }

  get showReimburseLink (): boolean {
    return this.custodianSettingsStore.allowReimbursement && !this.bankAccountStore.isBankAccountClosed;
  }

  get actionNeededBadgeClasses () {
    return {
      "action-needed-badge-1-digit": this.managedExpenseStore.actionNeededPreview.totalRecords < 10,
      "action-needed-badge-2-digit": this.managedExpenseStore.actionNeededPreview.totalRecords >= 10
    };
  }

  get showActionNeededBadge () {
    return this.managedExpenseStore.hasActionNeeded;
  }

  get managedExpenseFilterDestination (): ManagedExpenseFilterType {
    if (this.managedExpenseStore.hasActionNeeded) {
      return ManagedExpenseFilterType.ActionNeeded;
    }

    return ManagedExpenseFilterType.MyExpenses;
  }

  created () {
    this.expenseBalanceSummaryStore.loadState();
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getCustodianSettings();
    this.bankAccountStore.getBankAccountStatus();
    this.managedExpenseStore.loadActionNeededPreview();
  }

  get notionalNavItems () {
    return this.hsabAccountsStore.notionalAccounts.filter(t => t.isActive).map(t => {
      return {
        planType: t.planType,
        header: this.notionalAccountName(t),
        accountId: t.accountId,
        icon: hsabAccountIcon(t)
      };
    });
  }
  notionalAccountName (notionalAccount: HsabAccountNametag): string {
    return getNotionalAccountDisplay(notionalAccount);
  }
  get hsaIcon () {
    return hsaPlanTypeIcon();
  }
  get hasActiveAccount () {
    return this.hsabAccountsStore.userHasAnyActiveAccount;
  }
  openExpenseCreateModal () {
    this.hsabExpenseFormStore.modalType = HsabExpenseFormType.AdvNav;
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
  }
  beforeDestroy () {
    this.afterRoutedHook();
  }
}

